function del(obj, msg) {
    dialog.confirm(msg, function () {
        location.href = $(obj).attr('href');
    });
    return false;
}

function lang(key) {
    if (window.language && window.language[key]) {
        return window.language[key];
    }
    return key;
}

function ifempty(a, b) {
    if (a) {
        return a;
    }
    if (b) {
        return b;
    }
    return '';
}

function randomString(len, charSet) {
    charSet = charSet || 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var str = '', allLen = charSet.length;
    for (var i = 0; i < len; i++) {
        var randomPoz = Math.floor(Math.random() * allLen);
        str += charSet.substring(randomPoz, randomPoz + 1);
    }
    return str;
}

function parseObject(str) {
    try {
        var result = JSON.parse(str)
        if (result) {
            return result
        }
    } catch (e) {
        console.error(e)
    }
    return {};
}

function parseArray(str) {
    try {
        var result = JSON.parse(str)
        if (result instanceof Array) {
            return result
        }
    } catch (e) {
        console.error(e)
    }
    return [];
}

function strPad(str, len, pad) {
    str = str.toString();
    if (str.length >= len) return str;
    return strPad(pad + str, len, pad);
}

function copy_obj(arr) {
    return JSON.parse(JSON.stringify(arr));
}

function isObjectValueContains(a, b) {
    if (!a && !b) return true;
    if (!a || !b) return false;

    var aProps = Object.getOwnPropertyNames(a);

    for (var i = 0; i < aProps.length; i++) {
        var propName = aProps[i];

        if (a[propName] !== b[propName]) {
            return false;
        }
    }

    return true;
}

function isObjectValueEqual(a, b) {
    if (!a && !b) return true;
    if (!a || !b) return false;

    var aProps = Object.getOwnPropertyNames(a);
    var bProps = Object.getOwnPropertyNames(b);

    if (aProps.length != bProps.length) {
        return false;
    }

    for (var i = 0; i < aProps.length; i++) {
        var propName = aProps[i];

        if (a[propName] !== b[propName]) {
            return false;
        }
    }

    return true;
}

function array_combine(a, b) {
    var obj = {};
    for (var i = 0; i < a.length; i++) {
        if (b.length < i + 1) break;
        obj[a[i]] = b[i];
    }
    return obj;
}

function innerImage(ImgD, w, h) {
    var img = new Image();
    img.src = ImgD.src;
    var ow = img.width, oh = img.height, os = ow / oh, w = w || 100, h = h || w, s = w / h;
    if (os >= s) {
        if (ow > w) {
            ImgD.style.width = w + 'px';
            ImgD.style.height = w / os + 'px';
            oh = w / os;
        }
    } else {
        if (oh > h) {
            ImgD.style.height = h + 'px';
            ImgD.style.width = h * os + 'px';
            oh = h;
        }
    }
    if (oh < h) {
        if (ow < w) {
            ImgD.style.height = oh + 'px';
            ImgD.style.width = ow + 'px';
        }
        ImgD.style.marginTop = (h - oh) * .5 + 'px';
    } else {
        ImgD.style.marginTop = '0px';
    }
}
function overImage(o, w, h) {
    if (!$.isNumeric(w)) {
        var p = w || $(o).parent();
        h = p.height();
        w = p.width();
    }
    var img = new Image();
    img.src = o.src;
    var s = w / h, tw = img.width, th = img.height, ts = tw / th;
    if (ts >= s && th >= h) {
        o.height = h;
        o.width = h * ts;
        $(o).css({ marginLeft: (w - o.width) * .5 });
    } else if (ts <= s && tw >= w) {
        o.width = w;
        o.height = w / ts;
        $(o).css({ marginTop: (h - o.height) * .5 });
    } else {
        o.width = tw;
        o.height = th;
        $(o).css({ marginTop: (h - o.height) * .5 });
    }
}

function serializeObject(form) {
    var o = {}
    var data = $(form).serializeArray()
    for (var i = 0; i < data.length; i++) {
        var name = data[i].name
        if (o[name] !== undefined) {
            if (!o[name].splice) {
                o[name] = [o[name]]
            }
            o[name].push(data[i].value)
        } else {
            if (name.indexOf('[]') > 0) {
                o[name] = [data[i].value]
            } else {
                o[name] = data[i].value
            }
        }
    }
    return o;
}